import { render, staticRenderFns } from "./GFRun.vue?vue&type=template&id=12c65c50"
import script from "./GFRun.vue?vue&type=script&lang=js"
export * from "./GFRun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports